export default __webpack_public_path__ + "static/media/new-banner-removebg-preview.af6ac7e3.png";